import { render, staticRenderFns } from "./blockProductModal.vue?vue&type=template&id=d7e07e74&"
import script from "./blockProductModal.vue?vue&type=script&lang=ts&"
export * from "./blockProductModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports